export default __webpack_public_path__ + "static/GRID22-map-conflict-97e320df9714ceabc7beb61eb99e8472.png";